import React from "react";
import * as Yup from "yup";

import Form from "@Components/Form";
import { FORCE_UPDATE_URL } from "configs/constants";

const initialValues = {
  device_type: "",
  version: "",
  force_update: false,
};

const ForceUpdateForm = () => {
  const validationSchema = Yup.object({
    device_type: Yup.string().nullable().required("Device type is required"),
    version: Yup.string().nullable().required("App Version is required"),
    force_update: Yup.boolean().nullable().required("Force update is required"),
  });

  const formFields = [
    {
      type: "reactselect",
      variant: "outlined",
      name: "device_type",
      label: "Device Type",
      size: "small",
      outerOptions: [
        { id: "Android", name: "Android" },
        { id: "IOS", name: "IOS" },
      ],
      required: true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 9 },
    },
    {
      type: "input",
      variant: "outlined",
      autoComplete: "off",
      name: "version",
      size: "small",
      label: "Version",
      required: true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 9 },
    },
    {
      name: "force_update",
      type: "switch",
      label: "Force Update?",
      color: "primary",
      gridSize: { xs: 12 },
    },
  ];

  const formButtons = ["submit", "cancel"];

  return (
    <Form
      initialValues={initialValues}
      submitUrl={FORCE_UPDATE_URL}
      listRoute="/configurations/extra/force-update-settings"
      formFields={formFields}
      formButtons={formButtons}
      formTitle="App Version"
      isMultipart
      noListButton
      validationSchema={validationSchema}
    />
  );
};

export default ForceUpdateForm;
